<!-- <app-loader></app-loader> -->
<router-outlet></router-outlet>
<title>CLIENTA {{ page | titlecase }}</title>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>